var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 23.86 22.65"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.86v22.65H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#expand_svg__a)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.32 9.17c-.14.15-.14.38 0 .53l1.25 1.25H9.64a.38.38 0 1 0 0 .76h12.92l-1.25 1.25c-.15.15-.15.39 0 .54s.39.15.54 0l1.9-1.9c.15-.15.15-.38 0-.53l-1.9-1.9a.4.4 0 0 0-.54 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47 20.55c0 .72-.59 1.31-1.31 1.31H5.49V.79h10.67c.72 0 1.31.59 1.31 1.31v5.16c-.03.22.12.42.34.45s.42-.12.45-.34V2.1a2.1 2.1 0 0 0-2.1-2.1S2.83 0 2.83 0C1.27 0 0 1.27 0 2.83v16.99c0 1.56 1.27 2.83 2.83 2.83h13.33a2.1 2.1 0 0 0 2.1-2.1v-5.17a.397.397 0 0 0-.45-.34c-.18.03-.31.16-.34.34v5.16ZM4.7 21.86H2.83c-1.13 0-2.04-.91-2.04-2.04V2.83C.79 1.7 1.7.79 2.83.79H4.7z"
  }))));
};
export default SvgExpand;